import React, {Component} from "react";
import {Link, withRouter} from "react-router-dom";
import {withFirebase} from 'react-redux-firebase';
import {connect} from 'react-redux';

// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
// import Tooltip from "@material-ui/core/Tooltip";
// import {Apps, Settings, PowerSettingsNew, Explore} from "@material-ui/icons";

// import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";
import Button from "components/CustomButtons/Button.jsx";
import headerLinksStyle from "assets/jss/material-kit-react/components/headerLinksStyle.jsx";

class HeaderLinks extends Component {

  renderListItem(txt, linkPath, onClick=null) {
    const {classes} = this.props;
    return (
      <ListItem className={classes.listItem}>
        <Button size="sm" color="transparent" className={classes.navLink} onClick={onClick}>
          <Link style={{color: 'inherit'}} to={linkPath}>{txt}</Link>
        </Button>
      </ListItem>
    );
  }

  renderCTAButton(txt, linkPath) {
    const {classes} = this.props;
    return (
      <ListItem className={classes.listItem}>
        <Button size="sm" color="danger" className={classes.navLinkCTA}>
          <Link style={{color: 'inherit'}} to={linkPath}>{txt}</Link>
        </Button>
      </ListItem>
    );
  }

  render() {
    const {classes, profile} = this.props;
    const isLoggedIn = profile.username !== null;

    if (isLoggedIn) {
      return (
        <List className={classes.list}>
          {this.renderListItem('my polls', `/user/${profile.username}`)}
          {this.renderListItem('search', '/poll/search')}
          {this.renderListItem('trending', '/trending-polls')}
          {this.renderCTAButton('create poll', '/poll/create')}
        </List>
      );
    } else {
      return (
        <List className={classes.list}>
          {/* {this.renderListItem('login', '/user/login')} */}
          {this.renderListItem('signup', '/user/signup')}
          {this.renderListItem('search', '/poll/search')}
          {this.renderListItem('trending', '/trending-polls')}
          {this.renderCTAButton('create poll', '/poll/create')}
        </List>
      );
    }
  }
}

const pageWithStylesAndFirebase = withStyles(headerLinksStyle)(withFirebase(HeaderLinks));

function mapStateToProps(state) {
  return {
    profile: state.profile,
  };
}

export default withRouter(connect(mapStateToProps)(pageWithStylesAndFirebase));



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx